import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from './stores/useAuthStore.js';
import { ToastProvider } from './hooks/useToast.js';

import TitleBar from './components/TitleBar.js';
import Sidebar from './components/Sidebar.js';
import CourseRedirect from './components/CourseRedirect.js';

import Landing from './pages/Landing.js';
import Login from './pages/Login.js';
import Register from './pages/Register.js';
import Home from './pages/Home.js';
import Courses from './pages/Courses.js';
import LessonPlayer from './pages/LessonPlayer.js';
import Highlights from './pages/Highlights.js';
import UploadClip from './pages/UploadClip.js';
import Leaderboard from './pages/Leaderboard.js';
import UserProfile from './pages/UserProfile.js';
import PracticeMap from './pages/PracticeMap.js';
import Admin from './pages/Admin.js';
import Announcements from './pages/Announcements.js';

function MainLayout() {
  const { user, isInitialized } = useAuthStore();

  if (!isInitialized) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center text-on-surface-variant font-medium">
        <div className="flex flex-col items-center gap-3">
          <div className="w-8 h-8 border-2 border-error border-t-transparent rounded-full animate-spin"></div>
          <span>Synchronizing credentials...</span>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="flex flex-col min-h-screen">
      <TitleBar onSearch={(q) => console.log('Searching for:', q)} />
      <div className="flex flex-1 pt-10">
        <Sidebar />
        <main className="ml-[260px] flex-1 p-gutter max-w-[1440px] overflow-y-auto h-[calc(100vh-40px)]">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default function App() {
  const initializeAuth = useAuthStore((state) => state.initialize);

  useEffect(() => {
    initializeAuth();
  }, [initializeAuth]);

  return (
    <Router>
      <ToastProvider>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          <Route element={<MainLayout />}>
            <Route path="/home" element={<Home />} />
            <Route path="/courses" element={<Courses />} />
            <Route path="/courses/:id" element={<CourseRedirect />} />
            <Route path="/courses/:id/lessons/:lessonId" element={<LessonPlayer />} />
            <Route path="/highlights" element={<Highlights />} />
            <Route path="/upload" element={<UploadClip />} />
            <Route path="/leaderboard" element={<Leaderboard />} />
            <Route path="/profile/:username" element={<UserProfile />} />
            <Route path="/map" element={<PracticeMap />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/announcements" element={<Announcements />} />
            <Route path="*" element={<Navigate to="/home" replace />} />
          </Route>
        </Routes>
      </ToastProvider>
    </Router>
  );
}